import { Injectable } from '@angular/core';
import { Resolve, Router } from '@angular/router';
import { catchError, EMPTY, Observable } from 'rxjs';
import { OrganizationClient, OrganizationResponse } from '..';

@Injectable()
export class UserOrganizationsResolver implements Resolve<OrganizationResponse[]> {
  constructor(private readonly router: Router, private readonly organizationClient: OrganizationClient) {}

  resolve(): Observable<OrganizationResponse[]> {
    return this.organizationClient.getUserOrganizations(true).pipe(
      catchError((error) => {
        this.router.navigate(['errors/403']);

        this.organizationClient.notify(error);
        return EMPTY;
      })
    );
  }
}
